'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GlutenFreeSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GlutenFreeSvg(props) {
    var width = props.width,
        height = props.height,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'fullimgGF', width: width, height: height, viewBox: '0 0 15 27', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-full-gluten-free' },
        _react2.default.createElement(
            'title',
            { id: 'fullimgGF' },
            i18n.get('openrest_menubuilderv3_dishlabels_glutenfree') || 'Gluten Free'
        ),
        _react2.default.createElement('path', {
            d: 'M14.3435614 7.794l.001 2.668c.003.085.006.237 0 .449v.1c0 .01-.005.017-.006.027-.044 1.002-.3 2.937-1.574 4.184-1.535 1.503-4.038 1.511-4.7 1.485-.089.004-.218.005-.368.004l3.154-5.755c.761-.333 1.552-.476 2.193-.538l-.001-2.624c0-.359.291-.65.651-.65.359 0 .65.291.65.65zm-4.8711 10.5674c1.78-1.743 4.868-1.476 4.868-1.476s.204 3.094-1.576 4.837c-1.212 1.186-3.013 1.438-4.049 1.48v1.992c0 .359-.291.65-.65.65-.36 0-.651-.291-.651-.65v-1.993c-.741-.033-1.871-.176-2.9-.687l2.224-4.055c.757.791 1.141 1.825 1.326 2.73.192-.94.59-2.026 1.408-2.828zm4.9736-17.6074c.328.164.455.552.284.867l-13.465 24.714c-.12.219-.352.346-.595.346-.104 0-.209-.025-.31-.073-.328-.165-.455-.553-.284-.868l2.641-4.845c-1.073-1.746-.928-4.01-.928-4.01s1.435-.111 2.914.364l.516-.95c-.656-.22-1.313-.547-1.854-1.077-1.277-1.251-1.532-3.193-1.574-4.193-.001-.006-.004-.011-.004-.018v-.069c-.009-.256-.004-.44 0-.516l-.001-2.632c0-.359.291-.65.65-.65.36 0 .651.291.651.65l.001 2.619c1.055.101 2.532.433 3.569 1.448.229.224.416.474.581.733l.607-1.114c-.536-.524-2.149-2.272-2.132-4.354.012-1.61 1-3.005 1.702-3.797l-.001-2.679c0-.359.291-.65.65-.65.36 0 .651.291.651.65l.001 2.622c.641.734 1.548 2.038 1.666 3.553l3.159-5.799c.171-.313.573-.435.905-.272z',
            fill: primaryColor })
    );
}

GlutenFreeSvg.displayName = 'GlutenFreeSvg';
GlutenFreeSvg.propTypes = {
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
GlutenFreeSvg.defaultProps = {
    width: 15,
    height: 27,
    primaryColor: '#fbb446'
};